// @ts-check
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import countries from '@bottlebooks/react-common/src/countries';
const EMPTY = '(empty)';

export default function CountriesAutocomplete({
  initialValue,
  onChange,
  ...rest
}) {
  const options = [
    { key: EMPTY, label: 'Select' },
    ...Object.keys(countries).map((countryCode) => ({
      label: countries[countryCode],
      key: countryCode,
    })),
  ];
  return (
    <Autocomplete
      options={options.filter(Boolean)}
      disablePortal
      getOptionLabel={(field) => {
        const fieldSource = options.find(
          ({ key }) => key === field?.key || key === field
        );
        return fieldSource?.label || 'Select';
      }}
      getOptionSelected={(field, v) => {
        const fieldSource = options.find(
          ({ key }) => key === field?.key || key === field
        );
        return fieldSource?.key || EMPTY;
      }}
      value={initialValue || EMPTY}
      onChange={(e, value) => {
        onChange(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          name="selectBBFieldName"
          variant="outlined"
          fullWidth
        />
      )}
      {...rest}
    />
  );
}
